module.exports = __webpack_public_path__ + "img/desarchivar.22006bd9.svg";